import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ptl-sg-textarea',
  templateUrl: './sg-textarea.component.html',
  styleUrls: ['./sg-textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SgTextareaComponent),
      multi: true,
    },
  ],
})
export class SgTextareaComponent implements ControlValueAccessor {
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() label = '';
  @Input() description = '';
  @Input() disabled = false;
  @Input() rows = 4;
  @Input() maxLength: number | null = null;

  @Output() inputChange = new EventEmitter<string>();

  value = '';
  private onChange = (value: string) => {
    // ControlValueAccessor callback
  };
  private onTouched = () => {
    // ControlValueAccessor callback
  };

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
    this.inputChange.emit(this.value);
  }

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onBlur(): void {
    this.onTouched();
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
